import React from 'react';
import { useApp } from '../context/AppContext';

function ProfileDetails() {
  const { state } = useApp();
  const profile = state.userProfiles[state.selectedUser];

  if (!profile) {
    return (
      <div className="bg-gray-900/50 p-6 rounded-lg">
        <p className="text-gray-400 text-center">Select a user to view their profile</p>
      </div>
    );
  }

  const getInterruptToleranceColor = (tolerance) => {
    if (tolerance === 'Low') return 'text-red-400';
    if (tolerance === 'High') return 'text-green-400';
    return 'text-yellow-400';
  };

  return (
    <div className="bg-gray-900/50 p-6 rounded-lg space-y-4">
      <h2 className="text-2xl font-bold text-teal-300 mb-3">
        {profile.details.name}
      </h2>
      <p className="text-gray-300 leading-relaxed mb-4">
        {profile.summary}
      </p>
      
      {/* Core PWG Traits */}
      <div className="space-y-2 text-sm">
        <div>
          <span className="font-semibold text-gray-400">Role:</span> {profile.details.role}
        </div>
        <div>
          <span className="font-semibold text-gray-400">Prefers:</span> {profile.details.finish_line_style}
        </div>
        <div>
          <span className="font-semibold text-gray-400">Step Size:</span> {profile.details.step_size}
        </div>
        <div>
          <span className="font-semibold text-gray-400">Interrupt Tolerance:</span>{' '}
          <span className={`font-bold ${getInterruptToleranceColor(profile.details.interrupt_tolerance)}`}>
            {profile.details.interrupt_tolerance}
          </span>
        </div>
        <div>
          <span className="font-semibold text-gray-400">Motivation:</span> {profile.details.motivation}
        </div>
      </div>

      {/* Domains */}
      {profile.details.domains && profile.details.domains.length > 0 && (
        <div>
          <h3 className="font-semibold text-gray-400 mb-2">Domains</h3>
          <div className="flex flex-wrap gap-2">
            {profile.details.domains.map(domain => (
              <span key={domain} className="inline-block bg-teal-900 text-teal-200 text-xs font-semibold px-2.5 py-0.5 rounded-full">
                {domain}
              </span>
            ))}
          </div>
        </div>
      )}

      {/* Top Skills */}
      {profile.details.skills && profile.details.skills.length > 0 && (
        <div>
          <h3 className="font-semibold text-gray-400 mb-2">Top Skills</h3>
          <div className="space-y-2">
            {profile.details.skills.slice(0, 3).map(skill => (
              <div key={skill.name} className="flex justify-between text-sm">
                <span className="text-gray-300">{skill.name}</span>
                <span className="text-gray-400">Level {skill.level}/5</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Current Mission */}
      {profile.details.missions_led && profile.details.missions_led.length > 0 && (
        <div>
          <h3 className="font-semibold text-gray-400 mb-2">Leading Mission</h3>
          {profile.details.missions_led.map(mission => (
            <div key={mission.id} className="flex items-center justify-between p-2 bg-gray-700/50 rounded">
              <span className="font-medium text-sm">{mission.title}</span>
              <span className={`text-xs px-2 py-1 rounded-full ${
                mission.state === 'Committed' ? 'bg-yellow-500/20 text-yellow-300' : 'bg-green-500/20 text-green-300'
              }`}>
                {mission.state}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ProfileDetails;
